export class BlogCategory {
  public id: string;
  public blogCategoryId: number;
  public name: string;
  public detail: string;
  public blogCategoryIndex: string;
  public isActive: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/blog/blog-category-model.ts